import * as React from "react"

interface NoticeProps {
  readonly title: string
  readonly description: string
}

interface NoticeState {}

const noticeStateZero = {}

export class Notice extends React.Component<NoticeProps, NoticeState> {
  constructor(props: NoticeProps) {
    super(props)

    this.state = noticeStateZero
  }

  render() {
    const p = this.props

    return (
      <div className="block block--notice">
        <h2 className="title--s container--xs">{p.title}</h2>
        <div className="text--styled container--s" dangerouslySetInnerHTML={{ __html: p.description }} />
      </div>
    )
  }
}

{/* TH: Added to styleguide! */}
